import { createSlice } from "@reduxjs/toolkit";


// ------------------------------------------ Slice

// createSlice permet de fusionner action et reducer (modifi store)
export const skillsSlice = createSlice({
  name: "skills",
  initialState: {
    skillsGroups: [],
    skillGroupOnFocus: {},
    skillsAgents: [],
    skillAgentsOnFocus: {},
    skillsInterractions: [],
    sizeArrays: {}
  },
  reducers: {
    setSkillsGroups: (state, { payload }) => {
      state.skillsGroups = payload;

      // // Calcul du nombre d'agents par skillGroup
      // let arr1 = 0;
      // let arr2 = 0;

      // for (let i = 0; i < payload.values.length; i++) {
      //   if (payload.values[i].agentsTotal > 0) {
      //     arr1 = arr1 + payload.values[i].agentsTotal;
      //     if (payload.values[i].agentsAvailables > 0) {
      //       arr2 = arr2 + skillsGroupsWithAgentsData.values[i].agentsAvailables;
      //     }
      //   }
      // }
      // let sizeArrs = {
      //   exported: {
      //     withUnit: exportedArrSize.withUnit,
      //     withoutUnit: exportedArrSize.withoutUnit
      //   },
      //   new: {
      //     withUnit: newArrSize.withUnit,
      //     withoutUnit: newArrSize.withoutUnit
      //   },
      //   failed: {
      //     withUnit: failedArrSize.withUnit,
      //     withoutUnit: failedArrSize.withoutUnit
      //   },
      //   totalData: niceBytes(exportedArrSize.withoutUnit + newArrSize.withoutUnit + failedArrSize.withoutUnit, 1)
      // }
      // state.sizeArrays = sizeArrs;
    },
    setSkillsAgents: (state, { payload }) => {
      state.skillsAgents = payload;
    },
    setSkillsInterractions: (state, { payload }) => {
      state.skillsInterractions = payload;
    },
    setSkillGroupOnFocus: (state, { payload }) => {
      state.skillGroupOnFocus = payload;
    },
    setSkillAgentsOnFocus: (state, { payload }) => {
      state.skillAgentsOnFocus = payload;
    }
  },
});


// ------------------------------------------ Functions


// ------------------------------------------ Export

// On a l'action et le reducer au mm endroit
export const { setSkillsGroups, setSkillsAgents, setSkillsInterractions, setSkillGroupOnFocus, setSkillAgentsOnFocus } = skillsSlice.actions;
export default skillsSlice.reducer;
